import Microgame from '../engine/Microgame.js';

export default class TapGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: 'Tap !', en: 'Tap!', es: '¡Toca!' },
            controls: { fr: 'Appuie le plus vite possible sur l\'écran (ou clique)', en: 'Tap as fast as possible on the screen (or click)', es: 'Toca lo más rápido posible en la pantalla' },
            objective: { fr: 'Touche la cible lumineuse avant la fin du temps', en: 'Tap the glowing target before time runs out', es: 'Toca el objetivo brillante antes de que se acabe el tiempo' },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2a10 10 0 1 0 10 10 1 1 0 0 0-1-1h-9V2a1 1 0 0 0-1-1z"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path></svg>`,
            actions: [
                { type: 'wait', duration: 300 },
                { type: 'tapTarget', selector: '.tap-target', duration: 350 },
                { type: 'wait', duration: 320 },
                { type: 'tapTarget', selector: '.tap-target', duration: 350 },
                { type: 'wait', duration: 320 },
                { type: 'tapTarget', selector: '.tap-target', duration: 350 },
                { type: 'wait', duration: 450 },
            ],
            loopDuration: 2500
        };
    }
    constructor(engine) {
        super(engine);
        this.target = null;
    }

    setup() {
        console.log("TapGame Setup Starting...");
        this.engine.ui.instruction.textContent = "TAP IT!";

        // CLEANUP: Remove any existing targets to prevent duplicates (Zombie targets)
        const oldTargets = this.container.querySelectorAll('.tap-target');
        oldTargets.forEach(t => t.remove());

        this.target = document.createElement('div');
        this.target.className = 'tap-target';

        // Random position (keep within bounds)
        // Container is relative, so we use percentages
        const x = 10 + Math.random() * 80;
        const y = 10 + Math.random() * 80;

        this.target.style.left = `${x}%`;
        this.target.style.top = `${y}%`;
        this.target.style.backgroundColor = this.secondaryColor;
        this.target.style.boxShadow = `0 0 20px ${this.secondaryColor}`;

        this.container.appendChild(this.target);

        this.onTap = this.onTap.bind(this);
        this.engine.input.on('tap', this.onTap);
    }

    onTap(data) {
        if (!this.active) return;

        // Check collision (simple bounding box or distance)
        const rect = this.target.getBoundingClientRect();

        // Use normalized coordinates from InputHandler
        const x = data.x;
        const y = data.y;

        if (x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom) {
            // HIT!

            // Normal Mode
            this.win();
        }
    }

    cleanup() {
        super.cleanup();
    }
}
